
// middleware

export function delayMiddleware({dispatch}) {
    return (next) => (action) => {
        if (action.delayed) {
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve(next(action.delayed))
                }, action.time)
            })
        }
        return next(action)
    }
}

// action

export default function delay(delayed, time = 1500) {
    return {delayed, time}
}


// WEBPACK FOOTER //
// ./lib/core/redux/delay.js